import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { ChevronRight } from 'lucide-react'

const routeNames = {
  '': 'Dashboard',
  'users': 'Users',
  'teams': 'Teams',
  'payments': 'Financials',
  'subscriptions': 'Subscriptions',
  'invoices': 'Invoices',
  'support': 'Support',
  'communications': 'Communications',
  'analytics': 'Analytics',
  'settings': 'Settings',
  'alerts': 'Alerts',
  'developers': 'Developer Portal',
}

export default function Breadcrumbs() {
  const location = useLocation()
  const segments = location.pathname.split('/').filter(Boolean)

  if (segments.length === 0) {
    return <span className="text-sm font-medium text-gray-900">Dashboard</span>
  }

  const crumbs = segments.map((seg, i) => {
    const path = '/' + segments.slice(0, i + 1).join('/')
    const name = routeNames[seg] || seg.replace(/-/g, ' ').replace(/\b\w/g, c => c.toUpperCase())
    const isLast = i === segments.length - 1
    return { name, path, isLast }
  })

  return (
    <nav className="flex items-center gap-1 text-sm">
      <Link to="/" className="text-gray-500 hover:text-gray-700 transition-colors">
        Dashboard
      </Link>
      {crumbs.map((crumb) => (
        <React.Fragment key={crumb.path}>
          <ChevronRight className="w-3.5 h-3.5 text-gray-400" />
          {crumb.isLast ? (
            <span className="font-medium text-gray-900">{crumb.name}</span>
          ) : (
            <Link to={crumb.path} className="text-gray-500 hover:text-gray-700 transition-colors">
              {crumb.name}
            </Link>
          )}
        </React.Fragment>
      ))}
    </nav>
  )
}
